

import React, {useState} from 'react';
import { useTranslation } from "react-i18next";
import './ContactUs.css';
import { FaHandPointRight } from "react-icons/fa";
import FormatUrl from '../../utils/UrlFormatter';
import { notifySuccess, notifyError } from '../../utils/toastNotifications';



const ContactUs = ({account,  logged_in, user})=> {
    const { t } = useTranslation(); 

    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [subject, setSubject] = useState("");
    const [message, setMessage] = useState("");
    const [errorMsg, setErrorMsg] = useState(null);

    const handleChange = (e) => {
      const { name, value } = e.target;
      if (name === "name") setName(value);
      if (name === "email") setEmail(value);
      if (name === "phone") setPhone(value);
      if (name === "subject") setSubject(value);
      if (name === "message") setMessage(value);
    };

    const fetchCsrfToken = async () => {
      const csrfUrl = FormatUrl(`/csrf-token/`);
      const csrfResponse = await fetch(csrfUrl, {
        method: 'GET',
        credentials: 'include',
      });
      const csrfData = await csrfResponse.json();
      return csrfData.csrfToken;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!name || !email || !phone || !subject || !message) {
            setErrorMsg(t("contact.success_message"));
            notifyError(t("contact.success_message"));
            return;
        }
        try {
            const csrfToken = await fetchCsrfToken();
    
            // Prepare data for submission in the expected format using URLSearchParams
            const data = new URLSearchParams();
            data.append("name", name);
            data.append("email", email);
            data.append("phone_number", phone); // Ensure this matches the backend field
            data.append("subject", subject);
            data.append("message", message);
    
            const contactUrl = FormatUrl("/contact-submit/");
            const requestOptions = {
                method: "POST",
                headers: {
                    "X-CSRFToken": csrfToken,
                },
                body: data,
                credentials: "include",
            };
    
            const response = await fetch(contactUrl, requestOptions);
    
            if (!response.ok) {
                const errorText = await response.text();
                setErrorMsg("Error submitting the form: " + errorText);
                notifyError("Error submitting the form: " + errorText);
                return;
            }
    
            const result = await response.json();
            if (result.status === "success") {
                notifySuccess(t("contact.success_message"));
                setName("");
                setEmail("");
                setPhone("");
                setSubject("");
                setMessage("");
            }
        } catch (error) {
            setErrorMsg("An error occurred: " + error.message);
            notifyError("An error occurred: " + error.message);
        }
    };
    return (
        <>
        {/* Background Image Section */}
         <section className='contact-hero' id='contact'>
            <div className='contact-hero-banner'>
                <h2 style={{ lineHeight:1, color:"var(--clr-primary-8)"}}>{t("contact.header")}</h2>
                    <p style={{  fontSize:'1.5rem'}}>
                    {t("contact.subheader_one")}</p>
                    <p>
                    {t("contact.subheader_two")}
                    </p>
            </div>
        </section>

        {/* Address Map, Contact and Connect Form Section */}
        <section className="section ">

            <div className="section-title" style={{ marginTop: "4rem" }}>
                <h3>{t("contact.contact_us")}</h3>
                <div className="underline" style={{background:'var(--clr-primary-3)'}}></div>
            </div>
            <div className="contact-container">
                {/* <div className="map">
                    <iframe
                        src="https://maps.google.com/maps?q=105%20Owlridge%20Drive,%20Brampton,%20Ontario%20L6X%200M7,%20Canada&t=&z=13&ie=UTF8&iwloc=&output=embed"
                        title="Google Map Locator"
                        loading="lazy"
                    ></iframe>

                </div> */}
                <div className="info-card">
                    <h2>{t("contact.meet_us")}</h2>

                    <div className="info-description">
                    <p><FaHandPointRight className="icon-hand" /> {t("contact.description_one")}</p>
                    <p><FaHandPointRight className="icon-hand" /> {t("contact.description_two")}</p>
                    <p><FaHandPointRight className="icon-hand" /> {t("contact.questions")}</p>
                </div>

                    <div className="info-contact">
                        <div className="info-item">
                            <span>📞</span> <strong>+1 (905) 698-4149</strong>
                        </div>
                        <div className="info-item">
                            <span>📧</span> <a href="mailto:sales@siftconsultancy.com">sales@siftconsultancy.com</a>
                        </div>
                        {/* <div className="info-item">
                            <span>📍</span> 105 Owlridge Drive, Brampton, Ontario L6X 0M7, Canada
                        </div> */}
                    </div>
                </div>


            {/* todo - Need to add formData fields and corresponding values  */}
            <form className='form' style={{margin:'auto'}} onSubmit={handleSubmit}>

                <div className='form-row'>
                    <label htmlFor='name' className='form-label'>{t("contact.your_name")}</label>
                    <input
                    className='form-input'
                    type="text"
                    name="name"
                      value={name}
                      onChange={handleChange}
                    />
                </div>
                <div className='form-row'>
                <label htmlFor='email' className='form-label'>
                {t("contact.your_mail")}
                </label>
                    <input
                    className='form-input'
                    type="email"
                    name="email"
                      value={email}
                      onChange={handleChange}
                    />
                </div>

                <div className='form-row'>
                <label htmlFor='phone' className='form-label'>
                {t("contact.your_phone")}
                </label>
                <input
                    type='text'
                    className='form-input'
                    id='phone'
                    name='phone'
                    value={phone}
                    onChange={handleChange}
                />
                </div>

                <div className='form-row'>
                <label htmlFor='phone' className='form-label'>
                {t("contact.subject")}
                </label>
                <textarea
                    type='text'
                    className='form-input'
                    id='subject'
                    name='subject'
                    value={subject}
                    onChange={handleChange}
                />
                </div>

                <div className='form-row'>
                <label htmlFor='phone' className='form-label'>
                {t("contact.query")}
                </label>
                <textarea
                    type='text'
                    className='form-input'
                    id='message'
                    name='message'
                    value={message}
                    onChange={handleChange}
                />
                </div>

                    {/* Error Message */}
                    {errorMsg && <p>{errorMsg}</p>}

                {/* todo - Need to integrate an api on Clicking Submit button */}
                <button className='btn btn-block' type="submit">
                {t("contact.submit")}
                </button>

            </form>
            </div>
        </section>
        </>
    );
}

export default ContactUs;

